import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';
import './chart-overview-table.scss';

type Props = {
  data: { label: ReactElement | string | number; value: ReactNode }[];
  theme: string;
  className?: string;
};

export default function ChartOverViewTable({ className, theme, data }: Props): ReactElement {
  return (
    <table className={clsx('chart-overview-table', className)}>
      <thead>
        <tr className={clsx('report-header', { [theme]: theme })}>
          {data.map(({ label }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={`label-${i}`} className="label-holder">
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {data.map(({ value }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <td key={`value-${i}`} className="value-holder">
              {value}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
}
